import Vue from 'vue'
import Vuex from 'vuex'

import lele from './modules/lele'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    lele
  }
})
